export const headerPage = {
    init() {
        $(document).ready(function() {
            // body gets position: fixed while the menu is open (no scrolling behind it);
            // keep the scroll position, otherwise the page jumps to the top.
            $('.header__menu__btn').on('click',  function () {
                const $body = $('body');
                if (!$body.hasClass('header__menu__open')) {
                    const scrollY = window.scrollY;
                    $body.data('scroll-y', scrollY).css('top', -scrollY + 'px').addClass('header__menu__open');
                } else {
                    const scrollY = $body.data('scroll-y') || 0;
                    $body.removeClass('header__menu__open').css('top', '');
                    window.scrollTo(0, scrollY);
                }
            })
            $('.header__menu .menu-item-has-children').append('<span class="menu-item-touch"></span>')
            $('.menu-item-touch').on('click', function () {
                $(this).parent('.menu-item').toggleClass('open')
            })

            // if ($(window).width() > 767) {
                $(window).scroll(function () {
                    let scroll = $(window).scrollTop();
                    if (scroll > 60) {
                        $('.header').addClass('header--fix');
                    } else {
                        $('.header').removeClass('header--fix');
                    }
                });
            // }

            $('.header__search__toggle').on('click', function () {
                $('.header__search').toggleClass('open')
                $('.header__search__input input').focus()
            });
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
